import { ApiResponse } from '@shared/models';
import { WarehouseDto } from '@app/store/shared/models';
import { Warehouse } from './warehouse';

export class Warehouses {
    items: Warehouse[];
    total: number;

    constructor(response: ApiResponse<WarehouseDto[]>) {
        this.items = response.data.map((dto) => new Warehouse(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
